export default __webpack_public_path__ + "static/media/Ashoka_Particle_Flame_6.065ad56b.png";